import styled from 'styled-components';

export const Tr = styled.tr<{ $itemHeight: number }>`
  font-size: 14px;
  font-weight: 500;
  height: ${({ $itemHeight }) => $itemHeight}px !important;
  border-top: 1px solid ${({ theme }) => theme.colors.stroke};
`;
